import React from 'react';

const InlineErrorMessage = ({ errorMsg }) => {
  return <small className="text-danger">{errorMsg}</small>;
};

export default InlineErrorMessage;
